import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import TextField from '@material-ui/core/TextField';
import { Box, Grid, Tab, Tabs, ThemeProvider, createMuiTheme } from '@material-ui/core';
import GeneralInformation from './GeneralInformation';
import PersonData from './PersonData';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createMuiTheme({
    overrides: {
        MuiAppBar: {
            root: {
                borderBottomLeftRadius: '20px',
                borderBottomRightRadius: '20px',
                backgroundColor: '#484fdb', // Altere para a cor desejada
            },
        },
    },
});

export default function InformationEmployeeDialog({
    modalInformation
}) {

    const [selectedTab, setSelectedTab] = React.useState(0);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <div>
            <Dialog
                open={modalInformation.openModalInformation}
                onClose={modalInformation.handleCloseModalInformation}
                TransitionComponent={Transition}
                maxWidth="md"
                PaperProps={{
                    style: { borderRadius: 20 },
                }}
            >
                <AppBar position="static" style={{ backgroundColor: '#ffffff', color: '#4e525a' }}>
                    <Toolbar>
                        <Tabs value={selectedTab} onChange={handleChange} centered style={{ flexGrow: 1 }}>
                            <Tab label="Informações Gerais" />
                            <Tab label="Dados Pessoais" />
                        </Tabs>
                        <IconButton edge="end" color="inherit" aria-label="close" onClick={modalInformation.handleCloseModalInformation}>
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                {
                    selectedTab == 0 ?
                        <GeneralInformation informationEmployee={modalInformation.informationEmployee} capitalizeFirstLetter={modalInformation.capitalizeFirstLetter} />
                        :
                        <PersonData informationEmployee={modalInformation.informationEmployee} capitalizeFirstLetter={modalInformation.capitalizeFirstLetter}/>
                }

            </Dialog>
        </div>
    );
}
